import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Services from '@/components/Services'
import Hydro from '@/components/services/Hydro'
import Trees from '@/components/services/Trees'
import Rows from '@/components/services/Rows'
import Landscape from '@/components/services/Landscape'
import Irrigation from '@/components/services/Irrigation'
import Hydroaxe from '@/components/services/Hydroaxe'
import Portfolio from '@/components/Portfolio'
import Calculator from '@/components/Calculator'
import HydroCalculator from '@/components/HydroCalculator'
import Contact from '@/components/Contact'
import FourOhFour from '@/components/404'

Vue.use(Router)

export default new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {path: '/', name: 'home', component: Home},
        {
            path: '/services', name: 'services', component: Services, children: [
            {path: 'erosion-control', name: 'erosion', component: Hydro},
            {path: 'tree-relocation', name: 'trees', component: Trees},
            {path: 'row-maintenance', name: 'rows', component: Rows},
            {path: 'landscaping', name: 'landscape', component: Landscape},
            {path: 'irrigation', name: 'irrigation', component: Irrigation},
            {path: 'hydro-axing', name: 'hydroaxe', component: Hydroaxe},
        ]
        },
        {path: '/estimator', name: 'calculator', component: Calculator},
        {path: '/hydro', name: 'hydrocalc', component: HydroCalculator},
        {path: '/portfolio', name: 'portfolio', component: Portfolio},
        {path: '/contact', name: 'contact', component: Contact},
        {path: '/*', name: '404', component: FourOhFour},
    ],
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
})



// WEBPACK FOOTER //
// ./src/router/index.js